<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gxzQvn/images/cover.jpg?1685327318114" alt="This image is the cover for the book The Zero Knot"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Zero Knot
      </h1>
      <p class="bookDescription body article font2">
        <p>Eighteen-year-old Jess Bonner is casting off pretense—and, with it, some friends from his past who aren’t particularly trustworthy. In just a few months he’ll be starting college, and it’s time for him to admit the truth: he’s gay, not bi, and only one of his old friends holds any kind of real interest for him. When Dylan Finch, aka Mig, follows his lead and puts some distance between himself and the old crowd, he and Jess give in to a mutual attraction that’s been building for years.</p> <p>But navigating a fledgling relationship isn’t easy for beginners, and forces they can’t seem to control keep tripping them up: sexual appetite, personal insecurities, fear of discovery, and more. They need clarity. They need courage. Just as they’re on the verge of finding both, a vindictive act of jealousy sends one of them to jail. All their hard-won victories are in danger of falling to dust. And the only way to save what they have is to recognize it for what it is… and fight for its integrity.</p> <p><em><img alt="Rainbow Awards banner" height="133" src="http://dreamspinnerpress.com/images/promotional/rawinnerl.jpg" width="200"/><br/></em></p> <p><span>Second Place: Best LGBT Young Adult / Coming of Age</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        K.Z. Snow
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?97eb1fe6